import CROSSHAIR_PRESETS from './CROSSHAIR_PRESETS.json'
import RECOMMENDED_CROSSHAIRS from './RECOMMENDED_CROSSHAIRS.json'

export const CROSSHAIR_GALLERY = CROSSHAIR_PRESETS;
export const RECOMMENDED_GALLERY = RECOMMENDED_CROSSHAIRS;
